const {
  NODE_ENV,
  APP_ENV,
  SENTRY_PUBLIC_KEY,
  FILESTACK_PUBLIC_KEY,
  SITE_ANALYTICS_WRITEKEY
} = process.env

const GOOGLE_MAPS_API_KEY = 'AIzaSyCr_eG5MH279owFCp3QHbBd949g45PqjOU'
// Read the app version from the html so that it doesn't cause the main bundle
// to be cache busted on every deploy
const APP_VERSION = document.body.dataset.version

export {
  APP_ENV,
  APP_VERSION,
  NODE_ENV,
  SENTRY_PUBLIC_KEY,
  FILESTACK_PUBLIC_KEY,
  SITE_ANALYTICS_WRITEKEY,
  GOOGLE_MAPS_API_KEY
}
